import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class ArbitraryLineAPIs extends EarthBrainViewerAPIs {
    enableArbitraryLineCreation(callback, associatedTerrain) {
        this._scDesign.enableArbitraryLineCreation(callback, associatedTerrain);
    }
    /**
     * This Function will finish Trench Creation.
     */
    finishArbitraryCreation() {
        this._scDesign.finishArbitraryLineConstruction();
    }
    cancelArbitraryCreation(lineId) {
        this._scDesign.cancelArbitraryLineConstruction(lineId);
    }
    getArbitraryLineJSON(lineID) {
        return this._scDesign.getArbitraryLineJSON(lineID);
    }
    async loadArbitraryLineJSON(json) {
        return await this._scDesign.addArbitraryLinefromJSON(json);
    }
    deleteArbitraryLine(lineId) {
        return this._scDesign.deleteArbitraryLine(lineId);
    }
    toggleArbitraryLineVisibility(lineID, show) {
        this._scDesign.toggleArbitraryLineVisibility(lineID, show);
    }
    checkArbitraryLineUnderCreation() {
        return this._scDesign.checkArbitraryLineUnderCreation();
    }
    zoomToArbitrary(id) {
        this._scDesign.zoomToArbitrary(id);
    }
    exportArbitraryLineToSima(lineWorksId, siteName, filename = "output") {
        this._scDesign.exportArbitraryLineToSima(lineWorksId, siteName, filename);
    }
}
//# sourceMappingURL=arbitrary-line.js.map